import './style.scss'
import React from 'react'

export interface ToggleOption {
    label: React.ReactNode
    value: string
    disabled?: boolean
}

export interface OptionToggleProps {
    options: ToggleOption[]
    value?: string
    onChange?: (value: string) => void
    columns?: number
    gap?: string
    className?: string
}

export const OptionToggle: React.FC<OptionToggleProps> = ({
                                                              options, value, onChange, columns = 2, gap = '1.6rem', className = '',
                                                          }) => (
    <div
        className={`toggle ${className}`}
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)`, gap }}
    >
        {options.map((opt) => {
            const active = opt.value === value
            return (
                <button
                    type="button"
                    key={opt.value}
                    className={`toggle__option ${active ? 'is-active' : ''}`}
                    disabled={opt.disabled}
                    onClick={() => onChange?.(opt.value)}
                >
                    <span className={`toggle__radio ${active ? 'is-active' : ''}`} />
                    <span className="toggle__label">{opt.label}</span>
                </button>
            )
        })}
    </div>
)

export default OptionToggle